/* eslint-disable max-lines-per-function */
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { convertDate } from '../../../../utils/utility';
import { Modal } from '../../../common';
import {
  AdultIcon,
  BabyIcon,
  ChildIcon,
  PassengerIcon,
  EditIcon,
} from '~svg/index';

class TravelerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      travelerDetailModal: false,
      travelLst: [],
      data: { ...this.initialData },
    };
  }
  renderTravelerDetailModal = () => {
    let passengerList = JSON.parse(sessionStorage.getItem('passengers')),
      { direction } = this.props;
    return (
      <Modal
        title={
          <h5 className="modal-title text-center w-100 font-weight-bold text-captalize text-primary ">
            <FormattedMessage id="booking.travelerdetails" />
          </h5>
        }
        isOpen={this.state.travelerDetailModal}
        onClose={() => this.setState({ travelerDetailModal: false })}
      >
        <div className="modal-body d-flex  flex-column justify-content-center p-0 m-0">
          <table
            className="table  table-striped 
              text-center font-smaller table-bordered"
          >
            <thead className="bg-secondary text-white">
              <tr>
                <th scope="col">
                  <FormattedMessage id="booking.index" />
                </th>
                <th scope="col">
                  <FormattedMessage id="booking.passengertype" />
                </th>
                <th scope="col">
                  <FormattedMessage id="booking.firstname" />
                </th>
                <th scope="col">
                  <FormattedMessage id="booking.lastname" />
                </th>
                <th scope="col">
                  <FormattedMessage id="booking.nationalcode" />
                </th>
                <th scope="col">
                  <FormattedMessage id="profile.passportNumber" />
                </th>
                <th scope="col">
                  <FormattedMessage id="profile.birthdate" />
                </th>
                <th scope="col">
                  <FormattedMessage id="booking.passportexpiredate" />
                </th>
              </tr>
            </thead>
            <tbody className="">
              {passengerList && (
                <React.Fragment>
                  {passengerList.map((item, index) => {
                    return (
                      <tr key={`traveler-${index}`}>
                        <th scope="row">{index + 1}</th>
                        <td scope="row">
                          {item.type === 'child' && (
                            <ChildIcon size={22} color="#6c757d" />
                          )}
                          {item.type === 'adult' && (
                            <AdultIcon size={22} color="#6c757d" />
                          )}
                          {item.type === 'infant' && (
                            <BabyIcon size={22} color="#6c757d" />
                          )}
                        </td>
                        <td scope="row">{item.firstName}</td>

                        <td scope="row">{item.lastName}</td>
                        <td scope="row">
                          {item.nationalCode ? item.nationalCode : '--'}
                        </td>
                        <td scope="row">
                          {item.passportNo ? item.passportNo : '--'}
                        </td>
                        <td scope="row">
                          {item.birthDate
                            ? direction === 'ltr'
                              ? item.birthDate
                              : convertDate(item.birthDate, 'en', 'fa')
                            : '--'}
                        </td>
                        <td scope="row">
                          {item.passportExpireDate
                            ? direction === 'ltr'
                              ? item.passportExpireDate
                              : convertDate(item.passportExpireDate, 'en', 'fa')
                            : '--'}
                        </td>
                      </tr>
                    );
                  })}
                </React.Fragment>
              )}
            </tbody>
          </table>
        </div>
      </Modal>
    );
  };

  renderTravelList = () => {
    let { travelLst, data, direction } = this.props;

    if (travelLst.length && travelLst[0].firstName)
      return (
        <div className="text-white d-flex flex-column w-100 justify-content-between align-items-center pt-2 ">
          {travelLst?.map((item, index) => {
            if (item.index >= 0 && item.firstName)
              return (
                <div
                  key={`passenger-${index}`}
                  className={`d-flex ${
                    direction === 'rtl' ? 'flex-row-reverse' : ''
                  } col-12 justify-content-between align-items-center px-2 py-1 text-captalize text-white font-weight-bold`}
                >
                  <span className="d-flex text-white ">
                    {`${item.isMale ? 'Mr. ' : 'Mrs. '}`}
                    {`${item.firstName} / ${item.lastName}`}
                  </span>

                  <span
                    className="text-captalize font-weight-bold text-white pointer px-2"
                    onClick={() => this.props.editOnClick(item, index)}
                  >
                    <FormattedMessage
                      id="booking.edit"
                      defaultMessage="booking.edit"
                    />
                    <span className=" px-1" aria-hidden="true">
                      <EditIcon size={12} color="#85cd95" />
                    </span>
                  </span>
                </div>
              );
          })}

          {travelLst?.filter(
            (item) =>
              (
                item.nationalCode === data.nationalCode ||
                item.passportNo === data.passportNo
              ).length > 0,
          ) &&
            this.state.previousePassengerId === -1 && (
              <div className="d-flex py-1 px-1 text-captalize text-primary font-small font-weight-bold">
                {`${data.firstName} ${data.lastName}`}
              </div>
            )}
        </div>
      );
  };

  render() {
    let { travelLst } = this.props;
    return travelLst?.length && travelLst[0].firstName ? (
      <div className="d-flex px-0 flex-column font-smaller font-xl-small  w-100 font-weight-bold">
        <div className=" p-2 d-flex justify-content-between">
          <span className="d-flex align-items-center">
            <PassengerIcon size={22} color="#85cd95" />
            <span className="text-white px-2 ">
              <FormattedMessage
                id="booking.travelwith"
                defaultMessage="booking.travelwith"
              />
            </span>
          </span>
          <span
            className="cursor-pointer d-flex flex-end text-white text-underline font-smaller"
            onClick={() => this.setState({ travelerDetailModal: true })}
          >
            <FormattedMessage id="booking.travelerdetails" />
          </span>
        </div>
        <div>{this.renderTravelList()}</div>
        {this.renderTravelerDetailModal()}
      </div>
    ) : (
      <></>
    );
  }
}
export default injectIntl(TravelerList);
